import { useState, useEffect } from 'react'
import { MenuItem, Box, Grid, TextField, Divider, Typography } from '@mui/material'

function LeadMaternityCarer ({ onValidationChange, showErrors, formData, onFormDataChange }) {
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    onFormDataChange({ [name]: value })
  }

  useEffect(() => {
    const newErrors = {}
    const today = new Date()

    if (!formData.carerType?.trim()) newErrors.carerType = 'Carer Type is required.'
    if (!formData.carerFirstName?.trim()) newErrors.carerFirstName = 'First name is required.'
    if (!formData.carerSurname?.trim()) newErrors.carerSurname = 'Surname is required.'

    if (!formData.expectedDueDate) {
      newErrors.expectedDueDate = 'Expected due date is required.'
    } else if (new Date(formData.expectedDueDate) <= today) {
      newErrors.expectedDueDate = 'Expected due date must be in the future.'
    }

    if (!formData.proposedPlaceOfBirth?.trim()) newErrors.proposedPlaceOfBirth = 'Proposed place of birth is required.'

    if (!formData.gravida) {
      newErrors.gravida = 'Gravida is required.'
    } else if (isNaN(formData.gravida)) {
      newErrors.gravida = 'Gravida must be a number.'
    }

    if (!formData.parity) {
      newErrors.parity = 'Parity is required.'
    } else if (isNaN(formData.parity)) {
      newErrors.parity = 'Parity must be a number.'
    } else if (formData.parity > formData.gravida) {
      newErrors.parity = 'Parity must be lower than Gravida'
    }

    setErrors(newErrors)
    onValidationChange(Object.keys(newErrors).length === 0)
  }, [formData, onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Pregnancy & Maternity Information</Typography>
      <Typography variant='subtitle1' sx={{ mt: 2 }}>Lead Maternity Carer</Typography>

      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12 }}>
          <TextField
            select
            fullWidth
            label='Carer Type'
            name='carerType'
            value={formData.carerType || ''}
            onChange={handleChange}
            variant='outlined'
            error={showErrors && !!errors.carerType}
            helperText={showErrors && errors.carerType ? errors.carerType : ''}
            required
          >
            <MenuItem value='Independent Midwife'>Independent Midwife</MenuItem>
            <MenuItem value='DHB Community Wife'>DHB Community Midwife</MenuItem>
            <MenuItem value='Obstetrician'>Obstetrician</MenuItem>
          </TextField>
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label='First Name'
            name='carerFirstName'
            variant='outlined'
            value={formData.carerFirstName || ''}
            onChange={handleChange}
            error={showErrors && !!errors.carerFirstName}
            helperText={showErrors && errors.carerFirstName}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label='Surname'
            name='carerSurname'
            variant='outlined'
            value={formData.carerSurname || ''}
            onChange={handleChange}
            error={showErrors && !!errors.carerSurname}
            helperText={showErrors && errors.carerSurname}
            required
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            label='Name of Postnatal Midwife'
            name='postnatalMidwifeName'
            variant='outlined'
            value={formData.postnatalMidwifeName || ''}
            onChange={handleChange}
          />
        </Grid>

        <Grid size={{ xs: 12 }} sx={{ my: 2 }}> <Divider /> </Grid>

        <Grid size={{ xs: 12 }}>
          <Typography variant='subtitle1'>Pregnancy Information</Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label='Expected Due Date'
            type='date'
            slotProps={{ inputLabel: { shrink: true } }}
            name='expectedDueDate'
            value={formData.expectedDueDate || ''}
            onChange={handleChange}
            error={showErrors && !!errors.expectedDueDate}
            helperText={showErrors && errors.expectedDueDate}
            required
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label='Proposed Place of Birth'
            name='proposedPlaceOfBirth'
            variant='outlined'
            value={formData.proposedPlaceOfBirth || ''}
            onChange={handleChange}
            error={showErrors && !!errors.proposedPlaceOfBirth}
            helperText={showErrors && errors.proposedPlaceOfBirth}
            required
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            label='Gravida'
            name='gravida'
            variant='outlined'
            value={formData.gravida || ''}
            onChange={handleChange}
            error={showErrors && !!errors.gravida}
            helperText={showErrors && errors.gravida ? errors.gravida : 'Number of pregnancies you have had including this pregnancy'}
            required
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            label='Parity'
            name='parity'
            variant='outlined'
            value={formData.parity || ''}
            onChange={handleChange}
            error={showErrors && !!errors.parity}
            helperText={showErrors && errors.parity ? errors.parity : 'Number of babies previously born'}
            required
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default LeadMaternityCarer
